import React, { Component } from 'react'
import { fetchCampaign, deserializeCampaign } from 'supporticon/api/campaigns'

import Content from '../../ui/Content'
import Error from '../../ui/Error'
import Loading from '../../ui/Loading'
import ProgressTiles from '../../ui/ProgressTiles'
import Section from '../../ui/Section'

class CampaignTiles extends Component {
  constructor () {
    super()
    this.state = {
      status: 'fetching',
      data: []
    }
  }

  componentDidMount () {
    this.fetchCampaignDetails()
      .then((data) => this.setState({ status: 'fetched', data }))
      .catch(error => {
        this.setState({ status: 'failed' })
        return Promise.reject(error)
      })
  }

  fetchCampaignDetails () {
    const { items = [] } = this.props

    return Promise.all(
      items.map(campaign => (
        fetchCampaign(campaign.uid)
          .then(data => deserializeCampaign(data))
          .then(data => this.mergeCampaignContent(campaign, data))
      ))
    )
  }

  mergeCampaignContent (campaign, data) {
    const actions = [{
      label: campaign.donateLabel,
      to: campaign.donateUrl
    }, {
      label: campaign.getStartedLabel,
      to: campaign.getStartedUrl
    }]

    return {
      ...data,
      actions,
      image: campaign.image ? campaign.image.url : data.image,
      story: campaign.story ? campaign.story : data.summary,
      target: campaign.target ? campaign.target / 100 : data.target
    }
  }

  render () {
    const {
      alignment,
      backgroundImage,
      background,
      barColor,
      buttonBackground,
      buttonForeground,
      copy,
      copyAlignment,
      foreground,
      size,
      spacing,
      subtitle,
      title,
      titleForeground
    } = this.props

    const {
      data,
      status
    } = this.state

    return (
      <Section
        alignment={alignment}
        backgroundImage={backgroundImage}
        background={background}
        foreground={foreground}
        size={size}
        spacing={spacing}>

        <Content
          copy={copy}
          copyAlignment={copyAlignment}
          subtitle={subtitle}
          title={title}
          titleForeground={titleForeground}>

          {status === 'fetching' && <Loading />}
          {status === 'failed' && <Error>There was an error loading the data.</Error>}
          {status === 'fetched' && (
            <ProgressTiles
              barColor={barColor}
              buttonBackground={buttonBackground}
              buttonForeground={buttonForeground}
              data={data}
              titleForeground={titleForeground}
            />
          )}

        </Content>
      </Section>
    )
  }
}

export default CampaignTiles



// WEBPACK FOOTER //
// ./components/slices/CampaignTiles/index.js